<template>
  <div class="flex w-full h-full" style="border: 1px solid #EDEDED">
    <div class=" h-full flex-s-0" style="width: 50%;border-right: 1px solid #EDEDED">
      <slot name="left_title_lable">
        <div class="fs-16 flex a-center p-h-10" style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
          <slot name="classType">
            <div class="fs-14">分类</div>
          </slot>
          <div class="flex-1"></div>
          <div @click="onAddClassify" class="flex a-center" style="cursor: pointer" v-if="hideClassify">
            <img alt="" src="../../assets/common/ic_add.png"
                 style="width: 16px;height: 16px;margin-right: 5px">
            <span class="fs-14" style="color: #0652DD">添加</span>
          </div>
        </div>
      </slot>
      <div class="w-full o-y-auto" style="height: calc(100% - 50px)">
        <div class="p-t-10">
          <div class="w-full p-h-15 lh-40 h-40 " style=" background: #EDF3FF;" v-if="addClassifyShow">
            <Input @on-blur="addPicClassify()" class="inputBoder" ref="classAdd" v-model="addClassify"></Input>
          </div>
          <draggable
            @end="onClassListMoveEnd"
            @start="onClassListMovestart"
            class="list-group"
            element="ul"
            v-bind="dragOptions1"
            v-model="classifyDatas"
          >
            <li :class="{'active': objInfo.classId === item.id}" :key="index"
                @click="onClassSelect(item)"
                class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between"
                v-for="(item,index) in classifyDatas">
              <div class="o-hidden" v-if="item.id !== editClassId">
                <span style="white-space: nowrap">{{ item.name }}</span>
              </div>
              <Input @click.stop @on-blur="redactClassify(item)" autofocus class="inputBoder"
                     ref="classedit"
                     style="width: 200px"
                     v-model="item.name "
                     v-show="item.id === editClassId"></Input>

              <div :class="{'selectHover1':objInfo.classId === item.id}" class="selectHover d-none flex-s-0 m-l-10">
                <img @click.stop="onChangeValue(item,index)" alt="" class="w-15 h-15 m-r-10"
                     src="../../assets/common/ic_xiugai.png" style="cursor: pointer"
                     v-if="item.isDefault !==1">
                <img @click.stop="deleteClassify(item)" alt="" class="w-15 h-15 m-r-10"
                     src="../../assets/common/ic_shanchu1.png"
                     style="cursor: pointer" v-if="item.isDefault !==1">
                <img alt="" class="w-15 h-15 my-handle" src="../../assets/common/ic_tuozhuai.png"
                     style="cursor: pointer">
              </div>
            </li>
          </draggable>
        </div>
      </div>

    </div>
    <div class=" h-full flex-s-0" style="width: 50%">
      <slot name="right_title_lable">
        <div class="fs-16 flex a-center p-h-10" style="color: #333333;height: 50px;border-bottom: 1px solid #EDEDED;">
          <slot name="classType">
            <div class="fs-14">分组</div>
          </slot>
          <div class="flex-1"></div>
          <div @click="onAddGroup" class="flex a-center" style="cursor: pointer">
            <img alt="" src="../../assets/common/ic_add.png"
                 style="width: 16px;height: 16px;margin-right: 5px">
            <span class="fs-14" style="color: #0652DD">添加</span>
          </div>
        </div>
      </slot>

      <div class="w-full o-y-auto" style="height: calc(100% - 50px)">
        <div class="p-t-10">
          <div class="w-full p-h-15 lh-40 h-40 " style=" background: #EDF3FF;"
               v-if="addGroupShow">
            <Input @on-blur="addGroupsChange()" class="inputBoder" ref="gropAdd"
                   v-model="addGroupes"></Input>
          </div>
          <draggable
            @end="onGroupListMoveEnd"
            @start="onGroupListMovestart"
            class="list-group"
            element="ul"
            v-bind="dragOptions12"
            v-model="groupLists"
          >
            <li :class="{'active': objInfo.groupId === item.id}" :key="index"
                @click="onGroupSelect(item)"
                class="w-full p-h-15 lh-40 h-40 liHover flex a-center j-between"
                v-for="(item,index) in groupLists ">
              <div class="o-hidden" v-if="item.id !== editGroupId">
                <span style="white-space: nowrap">{{ item.name }}</span>
              </div>
              <Input @on-blur="redactGroups(item)" autofocus class="inputBoder" ref="groupedit"
                     style="width: 200px"
                     v-model="item.name"
                     v-show="item.id === editGroupId"></Input>
              <div
                :class="{'selectHover1':objInfo.groupId === item.id}"
                class="selectHover d-none flex-s-0 m-l-10">
                <img @click="onChangeGroup(item,index)" alt="" class="w-15 h-15 m-r-10"
                     src="../../assets/common/ic_xiugai.png" style="cursor: pointer"
                     v-if="item.isDefault !==1">
                <img @click="deleteGroups(item)" alt="" class="w-15 h-15 m-r-10"
                     src="../../assets/common/ic_shanchu1.png"
                     style="cursor: pointer" v-if="item.isDefault !==1">
                <img alt="" class="w-15 h-15 my-handle" src="../../assets/common/ic_tuozhuai.png"
                     style="cursor: pointer">
              </div>
            </li>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {mapActions} from 'vuex'
import Bus from '../../utils/bus'

export default {
  name: 'ClassGroupSettingWidget',
  components: {
    draggable,
  },
  props: {
    srcType: {        //资源类型
      type: Number,
      default: 0
    },

    objInfo: {      //选中结果
      classId: 0,
      className: '',
      groupId: 0,
      groupName: '',
      init: false
    },

    hideClassify: {   //隐藏分类添加功能
      type: Boolean,
      default: true
    },

    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyDatas: [],                 //分类数据数组
      addClassifyShow: false,            //添加分类显示
      addClassify: '',                   //新增分类文字存储字段,
      editClassId: '',                   //修改分类名称Id 负责切换分类编辑状态

      groupLists: [],                   //分组数据数组
      addGroupShow: false,              //添加分组显示
      addGroupes: '',                   //新增分组文字存储字段,
      editGroupId: '',                  //修改分组名称Id 负责切换分组编辑状态

      tempList: [],                     //临时存储拖动前数组
    }
  },
  computed: {
    dragOptions1 () {
      return {
        animation: 0,
        group: 'bdesc',
        handle: '.my-handle',
        ghostClass: 'ghost',
      }
    },
    dragOptions12 () {
      return {
        animation: 0,
        group: 'cdesc',
        handle: '.my-handle',
        ghostClass: 'ghost',
      }
    },
  },
  watch: {
    'objInfo.classId': {
      handler (newValue) {
        if (newValue) {
          if (this.objInfo.init) {
            return
          }
          this.objInfo.groupId = 0
          this.objInfo.groupName = ''
          if (newValue) {
            this.getGroupListDatas(newValue)
          } else {
            this.groupLists = []
            this.objInfo.groupId = 0
            this.objInfo.groupName = ''
          }
        }
      },
      immediate: true
    },
    open: {
      handler (newValue) {
        if (newValue) {
          this.init()
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      let res = await this.getClassifyData()
      this.classifyDatas = res
      if (this.objInfo.classId) {
        let sets = new Set()
        for (let i = 0; i < this.classifyDatas.length; i++) {
          sets.add(this.classifyDatas[i].id)
        }
        if (!sets.has(this.objInfo.classId)) {
          this.objInfo.classId = 0
          this.objInfo.className = ''
        } else {
          return
        }
      }
      if (this.classifyDatas && this.classifyDatas.length) {
        this.objInfo.classId = this.classifyDatas[0].id
        this.objInfo.className = this.classifyDatas[0].name
      } else {
        this.objInfo.classId = 0
        this.objInfo.className = ''
      }
    },

    // 渲染分类列表
    getClassifyData () {
      return new Promise((resolve, reject) => {
        let params = {
          type: this.srcType,
        }
        this.getCategoryLists(params).then((res) => {
          if (res.code === 0) {
            var arr = res.data
            resolve(arr)
          }
        })
      })
    },
    onClassSelect (item) {
      this.objInfo.classId = item.id
      this.objInfo.className = item.name
    },
    onAddClassify () {
      this.addClassify = ''
      this.addClassifyShow = true
      this.$nextTick(() => {
        this.$refs.classAdd.focus()
      })
    },
    addPicClassify () {
      if (!this.addClassify) {
        this.addClassifyShow = false
        return
      }
      if (this.addClassify) {
        let params = {
          name: this.addClassify,
          icon: '',
          desc: '',
          isDefault: '0',
          sort: '',
          type: this.srcType
        }
        this.addCategory(params).then(res => {
          if (res.code === 0) {
            this.getClassifyData().then((res) => {
              this.classifyDatas = res
              if (this.classifyDatas && this.classifyDatas.length) {
                this.objInfo.classId = this.classifyDatas[0].id
                this.objInfo.className = this.classifyDatas[0].name
              }
              this.addClassifyShow = false
              this.addClassify = ''
            })
            Bus.$emit('cgChange', {
              type: this.srcType,
              changeType: 11,      //11 类添加  12 类修改  13 类删除   21 组添加  22 组修改  23 组删除
              changeId: 0
            })
          } else {
            if (res.msg) {
              this.$Message.info(res.msg)
            }
          }
        })
      }
    },
    onChangeValue (item, index) {
      this.editClassId = item.id
      this.objInfo.classId = item.id
      this.objInfo.className = item.name
      this.$nextTick(() => {
        this.$refs.classedit[index].focus()
      })
    },
    redactClassify (data) {
      if (!data.name) {
        return this.$Message.info('请输入类型名称')
      }
      var id = data.id
      let params = {
        name: data.name,
        icon: data.icon,
        desc: data.desc,
        isDefault: data.isDefault,
        sort: data.sort,
        type: this.srcType
      }
      this.redactCategory({
        id,
        params,
      }).then(res => {
        if (res.code === 0) {
          this.getClassifyData().then((child) => {
            this.classifyDatas = child
            this.editClassId = ''
            if (this.objInfo.classId === id) {
              this.objInfo.className = data.name || ''
            }
          })
          Bus.$emit('cgChange', {
            type: this.srcType,
            changeType: 12,      //11 类添加  12 类修改  13 类删除   21 组添加  22 组修改  23 组删除
            changeId: id
          })
        } else {
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        }
      })
    },
    deleteClassify (item) {
      let params = {
        idList: item.id,
        type: this.srcType
      }
      this.delCategory(params).then(res => {
        if (res.code === 0) {
          this.getClassifyData().then(rres => {
            this.classifyDatas = rres
            if (this.objInfo.classId === item.id && this.classifyDatas && this.classifyDatas.length) {
              this.objInfo.classId = this.classifyDatas[0].id
              this.objInfo.className = this.classifyDatas[0].name
            }
            if (!(this.classifyDatas && this.classifyDatas.length)) {
              this.objInfo.classId = 0
              this.objInfo.className = ''
              this.groupLists = []
            }
          })
          Bus.$emit('cgChange', {
            type: this.srcType,
            changeType: 13,      //11 类添加  12 类修改  13 类删除   21 组添加  22 组修改  23 组删除
            changeId: item.id
          })
        }

      })
    },

    getGroupListDatas (pid) {
      return new Promise((resolve, reject) => {
        let params = {
          categoryId: pid,
          type: this.srcType
        }
        this.getGroupLists(params).then(childList => {
          this.groupLists = childList.data
          if (!this.objInfo.groupId) {
            if (this.groupLists && this.groupLists.length) {
              this.objInfo.groupId = this.groupLists[0].id
              this.objInfo.groupName = this.groupLists[0].name
            } else {
              this.objInfo.groupId = 0
              this.objInfo.groupName = ''
            }
          }
          resolve()
        })
      })
    },
    onGroupSelect (item) {
      this.objInfo.groupId = item.id
      this.objInfo.groupName = item.name
    },
    onAddGroup () {
      if (this.objInfo.classId) {
        this.addGroupes = ''
        this.addGroupShow = true
        this.$nextTick(() => {
          this.$refs.gropAdd.focus()
        })
      } else {
        this.$Message.warning('请选择分类')
      }
    },
    addGroupsChange () {
      if (!this.addGroupes) {
        this.addGroupShow = false
        return
      }
      if (!this.objInfo.classId) {
        return this.$Message.info('请选择分类')
      }

      if (this.addGroupes) {
        let params = {
          name: this.addGroupes,
          icon: '',
          desc: '',
          isDefault: '0',
          sort: '',
          categoryId: this.objInfo.classId,
          type: this.srcType
        }
        this.addGroup(params).then(res => {
          if (res.code === 0) {
            this.getGroupListDatas(this.objInfo.classId).then(() => {
              this.addGroupShow = false
              this.addGroupes = ''
            })
            Bus.$emit('cgChange', {
              type: this.srcType,
              changeType: 21,      //11 类添加  12 类修改  13 类删除   21 组添加  22 组修改  23 组删除
              changeId: 0
            })
          } else {
            if (res.msg) {
              this.$Message.info(res.msg)
            }
          }
        })
      }
    },
    onChangeGroup (item, index) {
      this.editGroupId = item.id
      this.objInfo.groupId = item.id
      this.objInfo.groupName = item.name
      this.$nextTick(() => {
        this.$refs.groupedit[index].focus()
      })
    },
    redactGroups (item) {
      if (!item.name) {
        return this.$Message.info('请输入分类名称')
      }
      let params = {
        // categoryId: this.objInfo.classId,
        name: item.name,
        icon: item.icon,
        desc: item.desc,
        isDefault: item.isDefault,
        sort: item.sort,
        id: item.id,
        type: this.srcType
      }
      var id = item.id
      if (item.name) {
        this.redactGroup({
          id,
          params
        }).then(res => {
          if (res.code === 0) {
            this.getGroupListDatas(this.objInfo.classId).then(() => {
              this.editGroupId = ''
            })
            Bus.$emit('cgChange', {
              type: this.srcType,
              changeType: 22,      //11 类添加  12 类修改  13 类删除   21 组添加  22 组修改  23 组删除
              changeId: id
            })
          } else {
            if (res.msg) {
              this.$Message.info(res.msg)
            }
          }
        })
      }
    },

    deleteGroups (data) {
      let params = {
        idList: data.id,
        type: this.srcType
      }
      this.delGroup(params).then(res => {
        if (res.code === 0) {
          this.getGroupListDatas(this.objInfo.classId).then(res => {
            if (this.objInfo.groupId === data.id && this.groupLists && this.groupLists.length) {
              this.objInfo.groupId = this.groupLists[0].id
              this.objInfo.groupName = this.groupLists[0].name
            }
            if (!(this.groupLists && this.groupLists.length)) {
              this.objInfo.groupId = 0
              this.objInfo.groupName = ''
            }
          })
          Bus.$emit('cgChange', {
            type: this.srcType,
            changeType: 23,      //11 类添加  12 类修改  13 类删除   21 组添加  22 组修改  23 组删除
            changeId: data.id
          })
        }
      })
    },


    onClassListMovestart (e) {
      this.isDragging = true
      this.tempList = JSON.parse(JSON.stringify(this.classifyDatas))
    },
    onClassListMoveEnd (e) {
      let oldIndex = e.oldIndex
      let newIndex = e.newIndex
      let id = this.tempList[oldIndex].id
      let sort = this.tempList[newIndex].sort
      this.tempList = []
      this.isDragging = false
      let params = {
        id,
        sort
      }
      this.sortClassType(params).then(res => {
        if (res.code !== 0) {
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        }
        Bus.$emit('cgChange', {
          type: this.srcType,
          changeType: 12,      //11 类添加  12 类修改  13 类删除   21 组添加  22 组修改  23 组删除
          changeId: 0
        })
        this.getClassifyData().then((child) => {
          this.classifyDatas = child
        })
      })
    },
    onGroupListMovestart (e) {
      this.isDragging = true
      this.tempList = JSON.parse(JSON.stringify(this.groupLists))
    },
    onGroupListMoveEnd (e) {
      let oldIndex = e.oldIndex
      let newIndex = e.newIndex
      let id = this.tempList[oldIndex].id
      let sort = this.tempList[newIndex].sort
      this.tempList = []
      this.isDragging = false
      let params = {
        id,
        sort
      }
      this.sortGroupType(params).then(res => {
        if (res.code !== 0) {
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        }
        Bus.$emit('cgChange', {
          type: this.srcType,
          changeType: 22,      //11 类添加  12 类修改  13 类删除   21 组添加  22 组修改  23 组删除
          changeId: 0
        })
        this.getGroupListDatas(this.objInfo.classId)
      })
    },
    ...mapActions([
      'getCategoryLists',
      'getGroupLists',
      'addCategory',
      'redactCategory',
      'delCategory',
      'addGroup',
      'redactGroup',
      'delGroup',
      'sortClassType',
      'sortGroupType'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .active {
    background: #EDF3FF;
    color: #0652DD;
  }

  .liHover:hover {
    background: #EDF3FF;
  }

  .selectHover1 {
    display: block;
  }

  .liHover:hover .selectHover {
    display: block;
  }

  .list-group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
  }

</style>
